import { BaseEntity } from "../common/baseEntity";
/**
 * Created by alex.y on 9/18/2017.
 */
export class ExtraData extends BaseEntity<number> {
    public ReferenceId: string;
    public ReferenceType: number;
    public Name: string;
    public Data: string;

    public constructor(init?: Partial<ExtraData>) {
        super();
        Object.assign(this, init);
    }
}


// WEBPACK FOOTER //
// ./app/objects/extraData/extraData.ts